import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ResponseSnackbarService} from '../../services/response-snackbar.service';
import {GeneralConstant} from '../../constants/GeneralConstant';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Subscription} from 'rxjs';
import * as FileSaver from 'file-saver';

export enum ExportType {
  PDF = 'pdf',
  XLS = 'xls',
  CSV = 'csv'
}

@Component({
  selector: 'app-table-exporter',
  templateUrl: './table-exporter.component.html',
  styleUrls: ['./table-exporter.component.scss']
})
export class TableExporterComponent {

  private subscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<TableExporterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private httpClient: HttpClient,
    private snackBar: ResponseSnackbarService
  ) {
    this.subscription = this.requestExport(data?.url, data?.params);
  }

  public cancelRequest() {
    this.subscription.unsubscribe();
    this.dialogRef.close();
  }

  private requestExport(url: string, params: any): Subscription {
    return this.httpClient.get(url, {
      params,
      responseType: 'arraybuffer',
      observe: 'response',
    }).subscribe((response: HttpResponse<ArrayBuffer>) => {
        const contentDisposition = response.headers.get('content-disposition');
        const body = response.body;
        if (params.type === 'pdf') {
          this.openFile(body, 'application/pdf');
        } else if (params.type === 'xls') {
          this.saveFile(body, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'xlsx', contentDisposition);
        } else if (params.type === 'csv') {
          this.saveFile(body, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'csv', contentDisposition);
        }
    });
  }

  public saveFile(data: ArrayBuffer, type: string, ext: string, contentDisposition?: string | null) {
    const filename =
      this.filenameFromContentDisposition(contentDisposition) ?? `export_${new Date().getTime()}.${ext}`;
    FileSaver.saveAs(new Blob([data], {type}), filename);
    this.dialogRef.close();
  }

  /**
   * Parses filename from Content-Disposition (RFC 5987 filename* and filename="..." / filename=...).
   */
  private filenameFromContentDisposition(header: string | null): string | null {
    if (!header) {
      return null;
    }
    const star = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(header);
    if (star) {
      try {
        return decodeURIComponent(star[1].trim().replace(/^"(.*)"$/, '$1'));
      } catch {
        return star[1].trim();
      }
    }
    const quoted = /filename="([^"]+)"/i.exec(header);
    if (quoted) {
      return quoted[1];
    }
    const plain = /filename=([^;]+)/i.exec(header);
    if (plain) {
      return plain[1].trim().replace(/^["']|["']$/g, '');
    }
    return null;
  }

  private openFile(data: any, type: string) {
    const blob = new Blob([data], {type});
    const url = window.URL.createObjectURL(blob);
    const pwa = window.open(url);
    this.dialogRef.close();
    if (!pwa || pwa.closed || typeof pwa.closed === 'undefined') {
      this.snackBar.onResponseMessage('Please disable your Pop-up blocker and try again.', GeneralConstant.SNACKBAR_ERROR_CLASS);
    }
  }
}
